import { colors, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  link: string;
  sharedMenuName: string;
  status: 'success' | 'failure';
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const SharedMenuLink = styled(Link)`
  ${typographyCss.Body3};
  font-weight: 500;
  margin-block-start: 8px;
  margin-inline-end: 16px;
  color: ${colors.wolt100};

  &:hover {
    color: ${colors.wolt92};
  }
`;

export const BootstrapNotificationToast = ({ link, sharedMenuName, status }: Props) => {
  return (
    <Root>
      <div>
        {status === 'success' && (
          <FormattedMessage
            id="shared-menu.editor.empty-menu.bootstrap.success.toast-header"
            values={{ name: sharedMenuName, bold: chunks => <b>{chunks}</b> }}
          />
        )}
        {status === 'failure' && (
          <FormattedMessage
            id="shared-menu.editor.empty-menu.bootstrap.failure.toast-header"
            values={{ name: sharedMenuName, bold: chunks => <b>{chunks}</b> }}
          />
        )}
      </div>
      <Actions>
        <SharedMenuLink to={link}>
          <FormattedMessage
            id="shared-menu.editor.empty-menu.bootstrap.toast-selection-link"
            values={{ name: sharedMenuName, bold: chunks => <b>{chunks}</b> }}
          />
        </SharedMenuLink>
      </Actions>
    </Root>
  );
};
